import { createApp } from 'vue';
import App from './App.vue';
import { OktaAuth } from '@okta/okta-auth-js'
import OktaVue from '@okta/okta-vue'
import { createWebHistory, createRouter } from "vue-router";
import home from './views/home';
import { LoginCallback,navigationGuard } from '@okta/okta-vue';

const routes = [
    {
        path: '/',
        component: home,
        meta: {
          requiresAuth: true
        }
    },
    {
        path: '/login/callback',
        component: LoginCallback
      },
]
const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});
router.beforeEach(navigationGuard);

router.beforeEach((to, from, next) => {
  document.title = 'FIG Bridge';
  next();
});

const oktaAuth = new OktaAuth({
  issuer: process.env.VUE_APP_OKTA_ISSUER,
  clientId: process.env.VUE_APP_OKTA_CLIENT_ID,
  scopes: ["openid", "profile", "email", "offline_access"],
  redirectUri: window.location.origin + '/login/callback',  
  pkce: true
})

const app = createApp(App);

app.use(router)
app.use(OktaVue, { oktaAuth });


app.mount('#app');
